/* 🤖 this file was generated by svg-to-ts */
export const siriusSignIn: {
  name: 'sign_in';
  data: string;
} = {
  name: 'sign_in',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M12.75 3a.75.75 0 0 0 0 1.5H18v15h-5.25a.75.75 0 0 0 0 1.5H18a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 18 3h-5.25Z" fill="currentColor"/><path d="M8.283 7.532a.75.75 0 0 1 1.061 0l3.937 3.938a.75.75 0 0 1 0 1.06l-3.937 3.938a.75.75 0 1 1-1.06-1.06l2.656-2.658H2.25a.75.75 0 0 1 0-1.5h8.69L8.283 8.593a.75.75 0 0 1 0-1.06Z" fill="currentColor"/></svg>`
};
